import { render, staticRenderFns } from "./gtr-card-inner.vue?vue&type=template&id=25d8f2eb"
import script from "./gtr-card-inner.ts?vue&type=script&lang=ts&external"
export * from "./gtr-card-inner.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports